// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"676":"fb870fa2","5103":"fb870fa2","8602":"fb870fa2"}[chunkId] + ".chunk.css";
};